/**
 * How long a clip kind may stay unresolved before the UI treats it as failed and renders its
 * terminal error state instead of an indefinite spinner (ENG-30186 child).
 *
 * Both windows are measured from `Incident.createdAt`, NOT from when the drawer opened, so
 * re-opening an old incident whose clip never landed shows the error immediately rather than
 * restarting the wait. That was the QA scenario: a 30-minute-old tailgate whose extended clip was
 * never associated with the TL event spun forever.
 *
 * Tune these to real pipeline latencies. `useIncidentVideo` also accepts per-call overrides
 * (`focusedFailureTimeoutMs` / `extendedFailureTimeoutMs`) for tests and future callers.
 */

/** Focused Clip = the resolved ORIGINAL/DOWNSCALED clip. */
export const FOCUSED_CLIP_FAILURE_TIMEOUT_MS = 5 * 60_000

/**
 * Extended Clip = the EXTENDED forensic clip, generated a few minutes after the incident
 * (ENG-31365). This doubles as the extended-clip polling give-up window, so polling stops at the
 * same instant the error state appears — there is never a spinner with no poll behind it, or a
 * poll behind an error state.
 *
 * Kept at the 5 minutes this polling window originally shipped with rather than the 15 the ticket
 * proposed: the clip is generated within a few minutes, so 15 left the operator watching a spinner
 * for three times longer than the pipeline needs. A clip that does arrive late still clears the
 * error state — `hasExtendedClipFailed` is derived, not latched.
 */
export const EXTENDED_CLIP_FAILURE_TIMEOUT_MS = 5 * 60_000
